// Production URL for email verification and auth redirects
export const PRODUCTION_URL = 'https://app.theslice.ai';

export const getAuthRedirectUrl = (path: string = '/') => {
  return `${PRODUCTION_URL}${path}`;
};
